export default __webpack_public_path__ + "static/media/inward.768e8a75.svg";